import flightimg from "../assest/images/flightimg.png";

const Welcome = () => {
    return (
        <section className="welcome">
            <div className="container">
                <div className="welcomeBox">
                    <div className="row">
                        <div className="col-6">
                            <div className="welcomeText">
                                <div className="sectionTitle">
                                    <h3>Welcome to <br /> ToursXplorer</h3>
                                    <p>Welcome to ToursXplorer.com, the ultimate destination for booking top-rated tours and activities in popular travel destinations around the world. Our platform offers a comprehensive selection of travel experiences, including city tours, cultural activities, adventure excursions, and much more. Whether you’re planning a trip to Bali, Algarve, Azores, Madeira Island, Paris, or New York City, we have a wide range of options to suit your interests and budget.</p>
                                    <p>Our team of travel experts has curated a collection of must-see destinations and experiences to make your trip unforgettable. We prioritize quality and safety, working only with trusted local partners to ensure that every tour is of the highest standard. Plus, our competitive pricing means that you can experience the best of each destination without breaking the bank.</p>
                                    <p>Booking with ToursXplorer.com is easy and convenient. Our website is user-friendly and optimized for mobile devices, allowing you to browse and book tours on-the-go.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="welcomeImg">
                                <img src={flightimg} alt="Flight Image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}
export default Welcome